// extracted by mini-css-extract-plugin
export default {"contain":"Footer_contain__OAh3f","links":"Footer_links__IdTAE","icons":"Footer_icons__m5xLj"};